module.exports = __webpack_public_path__ + "static/media/words.b04111a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/words.png
// module id = 1092
// module chunks = 0